import { render, staticRenderFns } from "./OrganizationMobileOverview.vue?vue&type=template&id=c835a464&scoped=true&lang=pug&"
import script from "./OrganizationMobileOverview.vue?vue&type=script&lang=js&"
export * from "./OrganizationMobileOverview.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationMobileOverview.vue?vue&type=style&index=0&id=c835a464&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c835a464",
  null
  
)

export default component.exports